/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Secret_InvalidInputs */

const es_co2_error_passkey_secret_invalid = /** @type {(inputs: Error_Passkey_Secret_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La llave no es válida.`)
};

/**

* @param {Error_Passkey_Secret_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_secret_invalid = /** @type {((inputs?: Error_Passkey_Secret_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Secret_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_secret_invalid(inputs)
});